import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { VendorPaymentsServiceProxy, VendorPaymentDto, Status, PaymentStatus, EntityDto, DropDownLookupDto, CommonLookupServiceProxy } from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';
import { UtilsService } from 'app/shared/common/utils/utils-service';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { HttpClient } from '@angular/common/http';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { finalize } from 'rxjs';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';
import * as moment from 'moment';

@Component({
    templateUrl: './vendorPayments.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class VendorPaymentsComponent extends AppComponentBase {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('ExcelFileUpload', { static: false }) excelFileUpload: FileUpload;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;

    advancedFiltersAreShown = false;
    filterText = '';

    vendorDisplayPropertyFilter = '';
    paymentTypeNameFilter = '';
    paymentStatus = PaymentStatus

    uploadUrl: string;
    allvendors: DropDownLookupDto[];
    allPaymentTypes: DropDownLookupDto[];
    allStatus: DropDownLookupDto[];
    vendorId: 0;
    paymentTypeId: 0;
    dateRangeSelected = false;
    receiptNo: '';
    invoiceNo: '';
    referenceNo: '';
    invoiceStatus = 0;
    dateRange: Date[] = [];
    constructor(
        injector: Injector,
        private _VendorPaymentsServiceProxy: VendorPaymentsServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _httpClient: HttpClient,
        public utilsService: UtilsService,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
    ) {
        super(injector);

        this.uploadUrl = AppConsts.remoteServiceBaseUrl + '/VendorPayments/ImportFromExcel';
    }

    ngOnInit(): void {
        this.initializeDateRange();
        this.populateDropDowns();
    }



    initializeDateRange() {
        const today = new Date();
        this.dateRange = [
            new Date(today.getFullYear(), today.getMonth(), today.getDate()),
            new Date(today.getFullYear(), today.getMonth(), today.getDate())
        ];
    }

    OnselectDateRange(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.dateRangeSelected = isChecked;

    }

    setDateRange(type: string) {
        const today = new Date();
        let start: Date, end: Date;

        switch (type) {
            case 'today':
                start = end = today;
                break;
            case '7days':
                start = new Date();
                start.setDate(today.getDate() - 6);
                end = today;
                break;
            case '30days':
                start = new Date();
                start.setDate(today.getDate() - 29);
                end = today;
                break;
            case 'thisMonth':
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case 'lastMonth':
                start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            default:
                start = end = today;
        }

        this.dateRange = [start, end];
    }

    populateDropDowns() {
        this._commonLookupServiceProxy.getAllVendorForTableDropdown().subscribe((result) => {
            this.allvendors = result;
            this.vendorId = 0;
        });

        this._commonLookupServiceProxy.getAllPaymentTypesForTableDropdown().subscribe((result) => {
            this.allPaymentTypes = result;
            this.paymentTypeId = 0;
        });

        this._commonLookupServiceProxy.getAllPurchaseInvoiceStatusForTableDropdown().subscribe((result) => {
            this.allStatus = result;
            this.invoiceStatus = 0;
        });
    }

    printVoucher(id: number): void {
        window.open(AppConsts.remoteServiceBaseUrl + '/Account/JournalVoucher/' + id, '_blank');
    }

    getVendorPayments(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();
        const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
        const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

        this._VendorPaymentsServiceProxy
            .getAll(
                this.vendorId,
                this.paymentTypeId,
                this.invoiceNo,
                this.receiptNo,
                this.referenceNo,
                this.dateRangeSelected,
                startDate ? DateTime.fromISO(startDate) : undefined,
                endDate ? DateTime.fromISO(endDate) : undefined,
                this.appSession.user.locationId,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createVendorPayment(): void {
        this._router.navigate(['/app/purchase/vendorPayments/createOrEdit']);
    }

    deleteVendorPayment(VendorPayment: VendorPaymentDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._VendorPaymentsServiceProxy.delete(VendorPayment.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }

    exportToExcel($event): void {
        this._VendorPaymentsServiceProxy
            .getVendorPaymentsToExcel(
                this.filterText,
                $event,
                this.vendorDisplayPropertyFilter,
                undefined,
                this.paymentTypeNameFilter,
                undefined,
            )
            .subscribe((result) => {
                this._fileDownloadService.downloadTempFile(result);
            });
    }

    uploadExcel(data: { files: File }): void {
        const formData: FormData = new FormData();
        const file = data.files[0];
        formData.append('file', file, file.name);

        this._httpClient
            .post<any>(this.uploadUrl, formData)
            .pipe(finalize(() => this.excelFileUpload.clear()))
            .subscribe((response) => {
                if (response.success) {
                    this.notify.success(this.l('ImportVendorPaymentsProcessStart'));
                } else if (response.error != null) {
                    this.notify.error(this.l('ImportVendorPaymentsUploadFailed'));
                }
            });
    }

    onUploadExcelError(): void {
        this.notify.error(this.l('ImportVendorPaymentsUploadFailed'));
    }

    resetFilters(): void {
        this.receiptNo = '';
        this.invoiceNo = '';
        this.referenceNo = '';
        this.vendorId = 0;
        this.paymentTypeId = 0;

        this.getVendorPayments();
    }

    showExcelColumnSelectionModal() {
        this._VendorPaymentsServiceProxy.getVendorPaymentExcelColumnsToExcel().subscribe((result) => {
            this.excelColumnSelectionModal.show(result);
        });
    }

    convertToDraft(vendorPayment: VendorPaymentDto): void {

        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this.primengTableHelper.showLoadingIndicator();
                var entitDto = new EntityDto();
                entitDto.id = vendorPayment.id;
                this._VendorPaymentsServiceProxy.convertVendorPaymentToDraft(entitDto).subscribe(() => {
                    this.getVendorPayments({});
                    this.notify.success(this.l('SuccessfullyDraft'));
                    this.primengTableHelper.hideLoadingIndicator();
                });
            }
        });
    }

    convertToPayment(vendorPayment: VendorPaymentDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                var entitDto = new EntityDto();
                this.primengTableHelper.showLoadingIndicator();
                entitDto.id = vendorPayment.id;
                this._VendorPaymentsServiceProxy.convertDraftToVendorPayment(entitDto).subscribe(() => {
                    this.getVendorPayments({});
                    this.notify.success(this.l('SuccessfullyConvertedToPayment'));
                    this.primengTableHelper.hideLoadingIndicator();
                });
            }
        });
        
    }
}
